<script lang="ts">
  import type { ResidenceTypes } from "../../helpers/types";

  interface Props {
    residenceType: ResidenceTypes | undefined;
  }

  let { residenceType }: Props = $props();
</script>

<div class="flex justify-between items-end w-full px-4">
  {#if residenceType === "apartment"}
    <div>
      <svg
        width="44"
        height="30"
        viewBox="0 0 44 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line y1="29" x2="44" y2="29" stroke="#E3E0DD" stroke-width="2" />
        <line x1="6" y1="1" x2="36" y2="1" stroke="#E3E0DD" stroke-width="2" />
        <rect x="9" y="1" width="24" height="28" stroke="#E3E0DD" stroke-width="2" />
        <rect x="12" y="7" width="2" height="4" stroke="#E3E0DD" stroke-width="2" />
        <rect x="12" y="17" width="2" height="4" stroke="#E3E0DD" stroke-width="2" />
        <rect x="18" y="7" width="2" height="4" stroke="#E3E0DD" stroke-width="2" />
        <rect x="18" y="17" width="2" height="4" stroke="#E3E0DD" stroke-width="2" />
        <rect x="24" y="7" width="2" height="4" stroke="#E3E0DD" stroke-width="2" />
        <rect x="24" y="17" width="2" height="4" stroke="#E3E0DD" stroke-width="2" />
      </svg>
    </div>
    <div>
      <svg
        width="61"
        height="40"
        viewBox="0 0 61 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line x1="17" y1="39" x2="61" y2="39" stroke="#E3E0DD" stroke-width="2" />
        <line x1="23" y1="1" x2="53" y2="1" stroke="#E3E0DD" stroke-width="2" />
        <rect x="26" y="1" width="24" height="38" stroke="#E3E0DD" stroke-width="2" />
        <rect x="29" y="7" width="2" height="4" stroke="#E3E0DD" stroke-width="2" />
        <rect x="29" y="17" width="2" height="4" stroke="#E3E0DD" stroke-width="2" />
        <rect x="29" y="27" width="2" height="4" stroke="#E3E0DD" stroke-width="2" />
        <rect x="35" y="7" width="2" height="4" stroke="#E3E0DD" stroke-width="2" />
        <rect x="35" y="17" width="2" height="4" stroke="#E3E0DD" stroke-width="2" />
        <rect x="35" y="27" width="2" height="4" stroke="#E3E0DD" stroke-width="2" />
        <rect x="41" y="7" width="2" height="4" stroke="#E3E0DD" stroke-width="2" />
        <rect x="41" y="17" width="2" height="4" stroke="#E3E0DD" stroke-width="2" />
        <rect x="41" y="27" width="2" height="4" stroke="#E3E0DD" stroke-width="2" />
        <mask id="path-13-inside-1_6809_12478" fill="white">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13 15.9646C14.6961 15.7219 16 14.2632 16 12.5C16 10.567 14.433 9 12.5 9C12.2497 9 12.0055 9.02628 11.7701 9.07622C11.1744 7.28873 9.48769 6 7.5 6C5.18368 6 3.27612 7.75009 3.02745 10.0001L3 10C1.34315 10 0 11.3431 0 13C0 14.3062 0.834808 15.4175 2 15.8293V16H3H12.5H13V15.9646Z"
          />
        </mask>
        <path
          d="M13 15.9646L12.7168 13.9847L11 14.2303V15.9646H13ZM11.7701 9.07622L9.87271 9.70857L10.4376 11.4034L12.1852 11.0327L11.7701 9.07622ZM3.02745 10.0001L3.01849 12.0001L4.81771 12.0082L5.01535 10.2198L3.02745 10.0001ZM3 10L3.00896 8H3V10ZM2 15.8293H4V14.4149L2.66649 13.9436L2 15.8293ZM2 16H0V18H2V16ZM13 16V18H15V16H13ZM13.2832 17.9444C15.9504 17.5629 18 15.2725 18 12.5H14C14 13.254 13.4419 13.881 12.7168 13.9847L13.2832 17.9444ZM18 12.5C18 9.46243 15.5376 7 12.5 7V11C13.3284 11 14 11.6716 14 12.5H18ZM12.5 7C12.1093 7 11.7261 7.04105 11.3551 7.11976L12.1852 11.0327C12.285 11.0115 12.39 11 12.5 11V7ZM13.6675 8.44387C12.8078 5.86419 10.3742 4 7.5 4V8C8.60119 8 9.541 8.71327 9.87271 9.70857L13.6675 8.44387ZM7.5 4C4.15286 4 1.39897 6.52826 1.03955 9.78043L5.01535 10.2198C5.15326 8.97192 6.2145 8 7.5 8V4ZM3.03641 8.00014L3.00896 8.00002L2.99104 12L3.01849 12.0001L3.03641 8.00014ZM3 8C0.238576 8 -2 10.2386 -2 13H2C2 12.4477 2.44772 12 3 12V8ZM-2 13C-2 15.1802 -0.605782 17.0295 1.33351 17.715L2.66649 13.9436C2.2754 13.8054 2 13.4323 2 13H-2ZM4 16V15.8293H0V16H4ZM3 14H2V18H3V14ZM12.5 14H3V18H12.5V14ZM13 14H12.5V18H13V14ZM11 15.9646V16H15V15.9646H11Z"
          fill="#E3E0DD"
          mask="url(#path-13-inside-1_6809_12478)"
        />
      </svg>
    </div>
  {:else}
    <div>
      <svg
        width="44"
        height="20"
        viewBox="0 0 44 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line y1="19" x2="44" y2="19" stroke="#E3E0DD" stroke-width="2" />
        <rect x="12" y="12" width="2" height="4" stroke="#E3E0DD" stroke-width="2" />
        <rect x="19" y="12" width="2" height="4" stroke="#E3E0DD" stroke-width="2" />
        <line x1="7" y1="20" x2="7" y2="6" stroke="#E3E0DD" stroke-width="2" />
        <line x1="26" y1="20" x2="26" y2="2" stroke="#E3E0DD" stroke-width="2" />
        <line x1="39" y1="20" x2="39" y2="9" stroke="#E3E0DD" stroke-width="2" />
        <line
          x1="3.81791"
          y1="6.01672"
          x2="30.8179"
          y2="1.01672"
          stroke="#E3E0DD"
          stroke-width="2"
        />
        <path d="M27.0664 7.50439L42.0664 9.50439" stroke="#E3E0DD" stroke-width="2" />
        <circle cx="31" cy="13" r="1" stroke="#E3E0DD" stroke-width="2" />
      </svg>
    </div>
    <div>
      <svg
        width="44"
        height="38"
        viewBox="0 0 44 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line y1="37" x2="44" y2="37" stroke="#E3E0DD" stroke-width="2" />
        <rect x="9" y="30" width="2" height="4" stroke="#E3E0DD" stroke-width="2" />
        <rect x="15" y="30" width="2" height="4" stroke="#E3E0DD" stroke-width="2" />
        <rect x="27" y="30" width="2" height="2" stroke="#E3E0DD" stroke-width="2" />
        <rect x="34" y="30" width="2" height="2" stroke="#E3E0DD" stroke-width="2" />
        <line x1="5" y1="38" x2="5" y2="15" stroke="#E3E0DD" stroke-width="2" />
        <line x1="26" y1="27" x2="26" y2="19" stroke="#E3E0DD" stroke-width="2" />
        <line x1="40" y1="38" x2="40" y2="27" stroke="#E3E0DD" stroke-width="2" />
        <line x1="21" y1="38" x2="21" y2="27" stroke="#E3E0DD" stroke-width="2" />
        <line x1="41" y1="26" x2="20" y2="26" stroke="#E3E0DD" stroke-width="2" />
        <line
          x1="1.17579"
          y1="14.0156"
          x2="29.1758"
          y2="19.0156"
          stroke="#E3E0DD"
          stroke-width="2"
        />
        <circle cx="10" cy="21" r="1" stroke="#E3E0DD" stroke-width="2" />
        <mask id="path-13-inside-1_6809_7754" fill="white">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M41 9.96456C42.6961 9.72194 44 8.26324 44 6.5C44 4.567 42.433 3 40.5 3C40.2497 3 40.0055 3.02628 39.7701 3.07622C39.1744 1.28873 37.4877 0 35.5 0C33.1837 0 31.2761 1.75009 31.0275 4.00012L31 4C29.3431 4 28 5.34315 28 7C28 8.30622 28.8348 9.41746 30 9.82929V10H31H40.5H41V9.96456Z"
          />
        </mask>
        <path
          d="M41 9.96456L40.7168 7.98471L39 8.23028V9.96456H41ZM39.7701 3.07622L37.8727 3.70857L38.4376 5.40342L40.1852 5.03268L39.7701 3.07622ZM31.0275 4.00012L31.0185 6.0001L32.8177 6.00817L33.0153 4.21982L31.0275 4.00012ZM31 4L31.009 2H31V4ZM30 9.82929H32V8.41494L30.6665 7.94361L30 9.82929ZM30 10H28V12H30V10ZM41 10V12H43V10H41ZM41.2832 11.9444C43.9504 11.5629 46 9.27252 46 6.5H42C42 7.25395 41.4419 7.881 40.7168 7.98471L41.2832 11.9444ZM46 6.5C46 3.46243 43.5376 1 40.5 1V5C41.3284 5 42 5.67157 42 6.5H46ZM40.5 1C40.1093 1 39.7261 1.04105 39.3551 1.11976L40.1852 5.03268C40.285 5.01151 40.39 5 40.5 5V1ZM41.6675 2.44387C40.8078 -0.135806 38.3742 -2 35.5 -2V2C36.6012 2 37.541 2.71327 37.8727 3.70857L41.6675 2.44387ZM35.5 -2C32.1529 -2 29.399 0.528256 29.0396 3.78043L33.0153 4.21982C33.1533 2.97192 34.2145 2 35.5 2V-2ZM31.0364 2.00014L31.009 2.00002L30.991 5.99998L31.0185 6.0001L31.0364 2.00014ZM31 2C28.2386 2 26 4.23858 26 7H30C30 6.44772 30.4477 6 31 6V2ZM26 7C26 9.18016 27.3942 11.0295 29.3335 11.715L30.6665 7.94361C30.2754 7.80538 30 7.43228 30 7H26ZM32 10V9.82929H28V10H32ZM31 8H30V12H31V8ZM40.5 8H31V12H40.5V8ZM41 8H40.5V12H41V8ZM39 9.96456V10H43V9.96456H39Z"
          fill="#E3E0DD"
          mask="url(#path-13-inside-1_6809_7754)"
        />
      </svg>
    </div>
  {/if}
</div>
